import { useState } from "react";
import { Box } from "@mui/material";
import { DotLegalButton, DotLegalPageHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import RiskReportKpiCards from "./RiskReportKpiCards";
import RiskReportCharts from "./RiskReportCharts";
import RiskManagementReportDialog from "./riskManagementReportDialog/RiskManagementReportDialog";
import { useRiskManagementReport } from "./RiskManagementReport.hooks";

function RiskManagementReport() {
    const { translateString } = useTranslation();

    const { isLoading, riskAppetiteLimit, risksAboveAppetite, isExceeded, coverage, risksOverAppetiteByArea, countAboveAppetite, exposureCards } =
        useRiskManagementReport();
    const [showDownloadDialog, setShowDownloadDialog] = useState(false);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <DotLegalPageHeader
                breadCrumbs={[{ name: translateString("riskManagementReport") }]}
                rightComponent={
                    <DotLegalButton buttonType="primary" onClick={() => setShowDownloadDialog(true)}>
                        {translateString("downloadReport")}
                    </DotLegalButton>
                }
            />

            <RiskReportKpiCards
                isLoading={isLoading}
                riskAppetiteLimit={riskAppetiteLimit}
                risksAboveAppetite={risksAboveAppetite}
                isExceeded={isExceeded}
                coverage={coverage}
                exposureCards={exposureCards}
            />

            <RiskReportCharts
                isLoading={isLoading}
                risksOverAppetiteByArea={risksOverAppetiteByArea}
                countAboveAppetite={countAboveAppetite}
                appetiteLimit={riskAppetiteLimit}
            />

            {showDownloadDialog && <RiskManagementReportDialog onDialogClose={() => setShowDownloadDialog(false)} />}
        </Box>
    );
}

export default RiskManagementReport;
